export const characterEncodings = ['ISO-8859-1', 'UTF-8'];
